export default __webpack_public_path__ + "static/media/landing-blockimg2.7ae8296f.jpg";